import { render, staticRenderFns } from "./BlogPostCardFilters3.vue?vue&type=template&id=3a973639&"
import script from "./BlogPostCardFilters3.vue?vue&type=script&lang=js&"
export * from "./BlogPostCardFilters3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports